import { ImageIcon } from '@primer/octicons-react';
import { Box } from '@primer/react';
import { ReactNode, useState } from 'react';
import { uploadApi } from '../../api/uploadApi';
import { NotifyHelper } from '../../helpers/toast';
import { IUploadResponeNew } from '../../models/response/upload/IUploadResponeNew';
import Text from '../ui/text';
// import { useDropzone } from 'react-dropzone';

interface IUploadProps {
    onUploadSuccess: (data: IUploadResponeNew) => void,
    accept?: any,
    subFolder?: string,
    render?: () => ReactNode
}
const Upload = (props: IUploadProps) => {
    const [isUploading, setIsUploading] = useState(false);
    // const accept: any = props.accept ? props.accept : {
    //     'image/*': [],
    //     'application/vnd.ms-excel': ['.xls', '.xlsx'],
    //     'application/pdf': [],
    //     'application/msword': ['.doc', '.docx'],
    //     'application/msg': ['.msg'],
    // }
    // const defaultAccept = {
    //     'image/*': []
    // };
    // const accept = props.accept || defaultAccept;

    const onDrop = async (acceptedFiles: any) => {
        if (acceptedFiles.length > 0) {
            setIsUploading(true)
            const res = await uploadApi.uploadFile(acceptedFiles[0], props.subFolder)
            setIsUploading(false)
            if (res.is_success) {
                props.onUploadSuccess(res.data)
            } else {
                NotifyHelper.Error(res.message ?? "Error")
            }
        }
    }

    const [isDragActive, setIsDragActive] = useState(false);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            onDrop(Array.from(files));
        }
    };

    const handleDragOver = (event: React.DragEvent) => {
        event.preventDefault();
        setIsDragActive(true);
    };

    const handleDragLeave = (event: React.DragEvent) => {
        event.preventDefault();
        setIsDragActive(false);
    };

    const handleDrop = (event: React.DragEvent) => {
        event.preventDefault();
        setIsDragActive(false);
        const files = event.dataTransfer.files;
        if (files && files.length > 0) {
            onDrop(Array.from(files));
        }
    };

    return (
        <Box>
            <div
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <input
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id="upload-input"
                    multiple={false}
                    accept=".xls,.xlsx,.pdf,.doc,.docx,.msg,image/*"
                />
                <label htmlFor="upload-input">
                    {props.render ? props.render() :
                    <Box sx={{
                        p: 3,
                        textAlign: "center",
                        borderStyle: "dashed",
                        borderWidth: "1px",
                        borderColor: "border.default",
                        borderRadius: 2,
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                        color: "fg.muted",
                        '&:hover': {
                            borderColor: 'accent.fg',
                            color: 'accent.fg'
                        }
                    }}>
                        {isUploading ? (
                            <Text text='Đang tải lên...' />
                        ) : (
                            <>
                                <ImageIcon size={24} />
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Text text='Kéo thả vào đây hoặc' />
                                    <Text text='Nhấn để chọn' />
                                </Box>
                            </>
                        )}
                    </Box>
                }
                </label>
            </div>
        </Box>
    );
};

export default Upload;